import { Component, OnInit, Input } from '@angular/core';
import { Helper } from '../../../helpers/helper';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ver-fotos-cliente',
  templateUrl: './ver-fotos-cliente.component.html',
  styleUrls: ['./ver-fotos-cliente.component.css']
})
export class VerFotosClienteComponent implements OnInit {
  @Input() cliente: any;
  @Input() fotos: string[];
  dirFotos = `${this.helper.baseUrl}/uploads/clientes/${this.helper.compania}`;

  constructor(
    private helper: Helper,
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit() {
    this.dirFotos += `/${this.cliente.cedula}/archivos`;
  }

}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/ver-fotos-cliente/ver-fotos-cliente.component.ts